module.exports = __webpack_public_path__ + "img/23.7.Chla.82287369.png";